<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="icon ion-bag"></i>
            <div class="mg-l-20">
              <h4>{{ $t("order.手工创建销售订单") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="card mg-x-50 pd-20 mg-y-20 card-subuser">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="mg-b-0 tx-gray-300">{{ $t("order.收货信息") }}</h5>
        </div>
        <form>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
                tx-white
              "
              >{{ $t("order.客户信息")
              }}<span class="tx-danger">*</span>：</label
            >
            <div class="col-md-3 col-sm-12">
              <SelectDistributor
                class="mg-b-10"
                :noLike="true"
                :key_id="keyDistributorId"
                :key_word="keyDistributorName"
                @changeKeyword="changeName"
                @keywordEnter="filtrateName"
                @keywordFilter="filtrateNameDefault"
                :create_user="true"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
                tx-white
              "
              >{{ $t("order.联系手机")
              }}<span class="tx-danger">*</span>：</label
            >
            <div class="col-md-3 col-sm-12">
              <input
                class="form-control tx-13 form-control-dark"
                :placeholder="$t('order.请输入联系手机')"
                v-model="mobile"
                :disabled="disabledInput"
              />
            </div>
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
                tx-white
              "
              >{{ $t("order.联系电话：") }}</label
            >
            <div class="col-md-3 col-sm-12">
              <input
                class="form-control tx-13 form-control-dark"
                :placeholder="$t('order.请输入联系电话')"
                v-model="telephone"
                :disabled="disabledInput"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
                tx-white
              "
              >{{ $t("order.收货地址")
              }}<span class="tx-danger">*</span>：</label
            >
            <div class="col-md-2 col-sm-12">
              <select
                class="form-control tx-13 form-control-dark"
                @change="selectProvince()"
                v-model="province"
                name="addressProvince"
                :disabled="disabledInput"
              >
                <option
                  v-for="(province, index) in selectCityArr"
                  :key="index"
                  v-text="province.name"
                  :value="index"
                ></option>
              </select>
            </div>
            <div class="col-md-2 col-sm-12">
              <select
                class="form-control tx-13 form-control-dark"
                @change="selectCity()"
                v-model="city"
                :disabled="cityArr.length < 1"
                name="addressCity"
              >
                <option
                  v-for="(city, index) in cityArr"
                  :key="index"
                  v-text="city.name"
                  :value="index"
                ></option>
              </select>
            </div>
            <div class="col-md-2 col-sm-12">
              <select
                class="form-control tx-13 form-control-dark"
                v-model="area"
                :disabled="areaArr.length < 1"
                name="addressArea"
              >
                <option
                  v-for="(area, index) in areaArr"
                  :key="index"
                  v-text="area.name"
                  :value="index"
                ></option>
              </select>
            </div>
            <div class="col-md-3 col-sm-12">
              <input
                class="form-control tx-13 form-control-dark"
                :placeholder="$t('order.请输入详细地址')"
                v-model="address"
                :disabled="disabledInput"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
                tx-white
              "
              >{{ $t("order.邮编：") }}</label
            >
            <div class="col-md-3 col-sm-12">
              <input
                class="form-control tx-13 form-control-dark"
                :placeholder="$t('order.请输入邮编')"
                v-model="zipCode"
                :disabled="disabledInput"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="br-pagebody" id="offerSkuList">
        <div class="card bd-gray-400 mg-x-20 pd-0 mg-t-30">
          <div class="d-flex align-items-center justify-content-between pd-20">
            <h5 class="mg-b-0 tx-gray-300">{{ $t("order.商品信息") }}</h5>
            <a href="javascript:;" class="btn btn-info" @click="addNewPro">{{
              $t("order.添加商品")
            }}</a>
          </div>
          <table class="table mg-b-0 table-contact data-table">
            <thead>
              <tr>
                <th class="wd-lg-300">{{ $t("order.商品信息") }}</th>
                <th class="wd-lg-150">{{ $t("order.商品单价") }}</th>
                <th class="wd-lg-150">{{ $t("order.数量") }}</th>
                <th class="wd-lg-150">{{ $t("order.总价") }}</th>
                <th class="wd-lg-300">{{ $t("order.备注") }}</th>
                <th class="wd-lg-150">{{ $t("order.操作") }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="skuItems.length > 0">
                <tr
                  class="tx-12"
                  v-for="(item, index) in skuItems"
                  :key="index"
                >
                  <td class="valign-middle">
                    <div class="media d-block d-sm-flex align-items-center">
                      <a
                        class="p-img-wrap mg-x-5"
                        href="javascript:;"
                        v-lazy:background-image="item.propertyImage"
                      >
                      </a>
                      <div class="p-info">
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.商品：") }}
                          <span class="tx-white">{{ item.skuName }}</span>
                        </p>
                        <p class="mg-b-0 tx-12">
                          SKU:
                          <span class="tx-white">{{
                            item.sku ? item.sku : "---"
                          }}</span>
                          <a
                            v-show="item.sku"
                            class="to-clipboard tx-info mg-l-5"
                            href="javascript:;"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </p>
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.重量(g):") }}
                          <span class="tx-white">{{
                            item.weight ? item.weight : "---"
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="valign-middle">
                    <input
                      v-PRICE
                      class="form-control tx-13 form-control-dark wd-100"
                      v-model="item.newprice"
                      @input="sumprice(item)"
                    />
                  </td>
                  <td class="valign-middle">
                    <input
                      v-INT
                      class="form-control tx-13 form-control-dark wd-100"
                      v-model="item.newquantity"
                      @input="sumprice(item)"
                    />
                  </td>
                  <td class="valign-middle">
                    <input
                      class="form-control tx-13 form-control-dark wd-100"
                      v-model="item.newtotal"
                      @input="sumprice(item)"
                      readonly="readonly"
                    />
                  </td>
                  <td class="valign-middle">
                    <input
                      class="form-control tx-13 form-control-dark wd-200"
                      v-model="item.newremark"
                    />
                  </td>
                  <td class="valign-middle">
                    <a
                      href="javascript:;"
                      class="tx-info tx-underline"
                      @click="remove(index)"
                      >{{ $t("order.移除") }}</a
                    >
                  </td>
                </tr>
              </template>
              <tr v-if="!skuItems || skuItems.length < 1">
                <td colspan="6">
                  <div class="col-12 none-product">
                    <i class="fa fa-ban"></i
                    >{{ $t("order.没有符合条件的数据") }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card mg-x-50 pd-20 mg-y-20 card-subuser">
        <div class="d-flex align-items-center justify-content-between mg-b-20">
          <h5 class="mg-b-0 tx-gray-300">{{ $t("order.订单备注") }}</h5>
        </div>
        <div class="">
          <textarea
            rows="5"
            class="form-control form-control-dark"
            v-model="remark"
          ></textarea>
        </div>
      </div>
      <div class="mg-x-50 pd-0 mg-y-30">
        <div class="d-flex align-items-center justify-content-between pd-0">
          <div>
            <span
              >{{ $t("order.商品合计：")
              }}<span class="tx-bold tx-danger mg-r-50">{{
                totalPrice
              }}</span></span
            >
            <span
              >{{ $t("order.商品总件数：")
              }}<span class="tx-bold tx-danger">{{ totalQuantity }}</span></span
            >
          </div>
          <a href="javascript:;" class="btn btn-info" @click="creatOrder()">{{
            $t("order.创建订单")
          }}</a>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
    <modalAddNewPro
      :open="addNewProOpen"
      @saveFn="saveFn"
      :id="keyDistributorId"
    ></modalAddNewPro>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor.vue"; //客户搜索
import modalAddNewPro from "./modal-add-sku.vue";

export default {
  components: {
    modalAddNewPro,
    SelectDistributor,
  },
  props: ["user_info", "white_style"],
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      address: "",
      province: "",
      city: "",
      area: "",
      selectCityArr: arrCity,
      cityArr: [],
      areaArr: [],
      addNewProOpen: Symbol(),
      skuItems: [],
      mobile: "",
      skus: [],
      remark: "",
      telephone: "",
      zipCode: "",
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      totalPrice: 0,
      totalQuantity: 0,
      keyRid: "",
      disabledInput: true,
    };
  },
  filters: {},
  created() {
    this.province = 0;
    this.city = 0;
    this.area = undefined;
    if (this.$route.query.id) {
      this.getInfo(this.$route.query.id);
      this.disabledInput = false;
    }
  },
  updated() {},
  watch: {
    keyRid: function () {
      if (this.keyRid) {
        this.getInfo(this.keyRid);
        this.disabledInput = false;
      }
    },
    keyDistributorName: function () {
      if (!this.keyDistributorName) {
        this.keyRid = this.keyDistributorId = "";
      }
    },
    keyDistributorId: function () {
      console.log(1);
      if (!this.keyDistributorId) {
        this.disabledInput = true;
        this.province = 0;
        this.city = 0;
        this.area = undefined;
        this.address = "";
        this.mobile = "";
        this.cityArr = [];
        this.areaArr = [];
      }
    },
  },
  methods: {
    getInfo(id) {
      this.loading = true;
      $.api_call(
        "api.Relationship.getRelationshipInfo",
        {
          relationId: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.cityArr = [];
            this.areaArr = [];
            if (r.Data.Results.province) {
              //选省
              for (let i = 0; i < this.selectCityArr.length; i++) {
                if (this.selectCityArr[i].name == r.Data.Results.province) {
                  this.province = i;
                  this.selectProvince();
                  break;
                }
              }
            } else {
              this.province = 0;
            }

            if (r.Data.Results.city) {
              //选市
              for (let i = 0; i < this.cityArr.length; i++) {
                if (this.cityArr[i].name == r.Data.Results.city) {
                  this.city = i;
                  if (i > 0) this.selectCity();
                  break;
                }
              }
            } else {
              this.city = 0;
            }

            if (r.Data.Results.area) {
              //选区
              for (let i = 0; i < this.areaArr.length; i++) {
                if (this.areaArr[i].name == r.Data.Results.area) {
                  this.area = i;
                  break;
                }
              }
            } else {
              this.area = undefined;
            }
            this.address = r.Data.Results.address;
            this.mobile = r.Data.Results.mobile;
            this.telephone = r.Data.Results.telephone;
            this.zipCode = r.Data.Results.zipCode;
            this.keyDistributorName = r.Data.Results.distributorName;
            this.keyDistributorId = r.Data.Results.distributorId;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    sumprice(item) {
      this.$set(
        item,
        "newtotal",
        this.formatNum(Number(item.newprice) * Number(item.newquantity), 4)
      );
      let priceArr = [];
      let quantityArr = [];
      this.totalPrice = 0;
      this.totalQuantity = 0;
      this.skuItems.forEach((item) => {
        quantityArr.push(Number(item.newquantity));
        priceArr.push(Number(item.newprice) * Number(item.newquantity));
      });
      priceArr.forEach((e) => {
        this.totalPrice += Number(e);
      });
      this.totalPrice = this.formatNum(this.totalPrice, 4);
      quantityArr.forEach((e) => {
        this.totalQuantity += Number(e);
      });
    },
    filtrateName(name, id, rId) {
      if (!id || id == "e999") {
        ShowTip(this.$t("order.请重新选择客户"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
        this.keyRid = "";
      } else {
        //清空按联系人
        this.keyDistributorName = name;
        this.keyDistributorId = id;
        this.keyRid = rId;
      }
    },
    filtrateNameDefault(name, id) {
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    changeName(name) {
      this.keyDistributorName = name;
    },
    creatOrder() {
      let skus = [];
      this.skuItems.forEach((e) => {
        skus.push({
          sku: e.sku,
          quantity: e.newquantity,
          price: e.newprice,
          skuRemark: e.newremark,
        });
      });
      let param = {
        distributorId: this.keyDistributorId,
        mobile: this.mobile,
        province: this.province
          ? this.selectCityArr[this.province].name
          : undefined, //省份
        city: this.city ? this.cityArr[this.city].name : undefined, //城市
        area:
          this.area || this.area === 0
            ? this.areaArr[this.area].name
            : undefined, //区域
        address: this.address,
        skus: skus,
        remark: this.remark,
        telephone: this.telephone,
        zipCode: this.zipCode,
      };
      this.loading = true;
      $.api_call("api.Order.createBySupplier", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("order.手工创建销售订单成功"), "success");
          setTimeout(() => {
            this.$router.push({
              path: "order-manager",
              query: {
                ver: 2,
              },
            });
          }, 1000);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    remove(i) {
      this.skuItems.splice(i, 1);
      ShowTip(this.$t("order.删除商品成功"), "success");
    },
    saveFn(data) {
      let arr = [];
      let num = 0;
      if (data.length > 0) {
        data.forEach((e) => {
          this.skuItems.forEach((s) => {
            if (e.id == s.id) {
              num++;
            }
          });
        });
      }
      if (num > 0) {
        ShowTip(this.$t("order.不能重复添加商品，请重新选择"), "danger");
      } else {
        data.forEach((e) => {
          this.skuItems.push(e);
        });
        ShowTip(this.$t("order.添加商品成功"), "success");
        $("#modalAddNewPro").modal("hide");
      }
      this.skuItems.forEach((e) => {
        this.$set(e, "newprice", e.price);
        this.$set(e, "newquantity", "0");
        this.$set(e, "newtotal", Number(e.newprice) * Number(e.newquantity));
        this.$set(e, "newremark", "");
      });
    },
    addNewPro() {
      this.addNewProOpen = Symbol();
      $("#modalAddNewPro").modal("show");
    },
    selectProvince() {
      this.city = 0;
      this.area = undefined;
      this.cityArr = [];
      this.areaArr = [];
      let p = this.province;
      if (this.selectCityArr[p] && this.selectCityArr[p].sub) {
        this.cityArr = this.selectCityArr[p].sub;
      } else {
        this.cityArr = [];
      }
    },
    selectCity() {
      this.area = undefined;
      let c = this.city;
      if (!c) return;
      if (this.cityArr[c].sub) {
        this.areaArr = this.cityArr[c].sub;
      } else {
        this.areaArr = [];
      }
    },
  },
};
</script>

<style scoped="scoped">
.show-white-style .tx-white {
  color: #343a40 !important;
}
.img-wrap {
  border: 1px rgba(0, 0, 0, 0.3) solid;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.data-table tbody tr.bg-gray-300:hover,
.data-table .hover:hover {
  background-color: #dee2e6 !important;
}
</style>